// Module
var code = " <div class=\"react-container react-zoom\"> <login-page/> </div> ";
// Exports
module.exports = code;